import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { useForm } from 'react-hook-form/dist/react-hook-form.ie11';
import SvgIcon from '@material-ui/core/SvgIcon';
import Lock from '../icons/lock.svg';
import { Container, Form, Row, Col } from "react-bootstrap";
import { customValidators, object, string } from '../../../Helpers/Validators/customValidators'
import { SelectInput, TextInput, StyledRadioInput } from "../../../Helpers/Inputs";
import GetStateListForAflac from '../Helpers/StateListForAflac';
import { InputMaskPhone } from "../../../Helpers/Formatters";
import BackNext from '../../Common/SubComponents/BackNext';
export default function ThirdPartyDemoGraphic(props) {
    const { register, errors, handleSubmit, setValue, triggerValidation } = useForm({
        validationSchema: ThirdPartyDemoGraphic.ValidationSchema,
        mode: 'onBlur',
        reValidateMode: 'onBlur',
    });
    const handleValueChange = (field, value) => {
        setValue(field, value);
        props.onFieldChange(field, value);
        triggerValidation(field);
    };

    useEffect(() => {
        register({ name: 'includeSecondaryAddressee' });
        setValue('includeSecondaryAddressee', props.formState.includeSecondaryAddressee);

        register({ name: 'firstName' });
        setValue('firstName', props.formState.firstName);

        register({ name: 'middleInitial' });
        setValue('middleInitial', props.formState.middleInitial);

        register({ name: 'lastName' });
        setValue('lastName', props.formState.lastName);

        register({ name: 'street' });
        setValue('street', props.formState.street);

        register({ name: 'city' });
        setValue('city', props.formState.city);

        register({ name: 'state' });
        setValue('state', props.formState.state);

        register({ name: 'zip' });
        setValue('zip', props.formState.zip);

        register({ name: 'phoneNumber' });
        setValue('phoneNumber', props.formState.phoneNumber);

    }, [register])

    const onSubmit = () => {
        props.onNext();
    };
    const SeclectBoxOption = [
        { value: 'yes', label: 'Yes' },
        { value: 'no', label: 'No' },
    ];

    const getDisabled = (props.formState.includeSecondaryAddressee === "yes" && (props.formState.firstName === '' || props.formState.middleInitial === '' || props.formState.lastName === ''
        || props.formState.street === '' || props.formState.city === '' || props.formState.state === ''
        || props.formState.zip === '' || props.formState.phoneNumber === ''));

    return (
        <Container fluid className='border-class'>
            <Row className="ThirdParty justify-content-center">
                <Col>
                    <Row className="justify-content-center mt-4">
                        <Col className='col-div'>
                            <div className="text-center mb-2 pt-4"><SvgIcon component={Lock} className="small-icons" color="primary" fontSize="large" /></div>
                            <div className="text-center form-title">Third Party Information</div>
                            <div className="text-center">You have the right to designate a person other than yourself to receive notice of lapse or termination of this insurance policy for nonpayment of premium.</div>
                        </Col>
                    </Row>

                    <Form onSubmit={handleSubmit(onSubmit)}>
                        <Row className="justify-content-center pt-4">
                            <Col lg={5}>
                                <h6 className='pb-2'>Do you wish to name a third party at this time?</h6>
                                <Form.Group>
                                    <StyledRadioInput
                                        name="includeSecondaryAddressee"
                                        id="includeSecondaryAddressee"
                                        value={props.formState.includeSecondaryAddressee}
                                        options={SeclectBoxOption}
                                        onChange={(e) => handleValueChange('includeSecondaryAddressee', e)}
                                        errors={errors && errors.includeSecondaryAddressee}
                                        isWhiteBackground={true}
                                        isBlankIcon={true}
                                    />
                                </Form.Group>
                                {props.formState.includeSecondaryAddressee === "yes" && (
                                    <React.Fragment>
                                        <Form.Group>
                                            <TextInput
                                                name="firstName"
                                                id="firstName"
                                                label="First Name"
                                                value={props.formState.firstName}
                                                onChange={e => handleValueChange('firstName', e.target.value)}
                                                errors={errors.firstName}
                                                inputRef={register}
                                                inputProps={{
                                                    maxLength: 20,
                                                }}
                                            />
                                        </Form.Group>
                                        <Form.Group>
                                            <TextInput
                                                name="middleInitial"
                                                id="middleInitial"
                                                label="Middle Initial"
                                                value={props.formState.middleInitial}
                                                onChange={e => handleValueChange('middleInitial', e.target.value)}
                                                errors={errors.middleInitial}
                                                inputRef={register}
                                                inputProps={{
                                                    maxLength: 2,
                                                }}
                                            />
                                        </Form.Group>
                                        <Form.Group>
                                            <TextInput
                                                name="lastName"
                                                id="lastName"
                                                label="Last Name"
                                                value={props.formState.lastName}
                                                onChange={e => handleValueChange('lastName', e.target.value)}
                                                errors={errors.lastName}
                                                inputRef={register}
                                                inputProps={{
                                                    maxLength: 50,
                                                }}
                                            />
                                        </Form.Group>
                                        <Form.Group>
                                            <p className="section-title">Street Address</p>
                                            <TextInput
                                                name="street"
                                                id="street"
                                                label="Street Address"
                                                value={props.formState.street}
                                                onChange={e => handleValueChange('street', e.target.value)}
                                                errors={errors.street}
                                                inputRef={register}
                                                inputProps={{
                                                    maxLength: 40,
                                                }}
                                            />
                                        </Form.Group>
                                        <Form.Group>
                                            <TextInput
                                                name="city"
                                                id="city"
                                                label="City"
                                                value={props.formState.city}
                                                onChange={e => handleValueChange('city', e.target.value)}
                                                errors={errors.city}
                                                inputRef={register}
                                                inputProps={{
                                                    maxLength: 40,
                                                }}
                                            />
                                        </Form.Group>
                                        <Row>
                                            <Col>
                                                <Form.Group>
                                                    <SelectInput
                                                        name="state"
                                                        id="state"
                                                        value={props.formState.state}
                                                        onChange={(e) => handleValueChange('state', e.target.value)}
                                                        label="State"
                                                        selectOptions={GetStateListForAflac()}
                                                        errors={errors && errors.state}
                                                        inputRef={register}
                                                    />
                                                </Form.Group>
                                            </Col>
                                            <Col>
                                                <Form.Group>
                                                    <TextInput
                                                        name="zip"
                                                        id="zip"
                                                        label="Zip"
                                                        value={props.formState.zip}
                                                        onChange={e => handleValueChange('zip', e.target.value)}
                                                        errors={errors.zip}
                                                        inputRef={register}
                                                        inputProps={{
                                                            maxLength: 5,
                                                        }}
                                                    />
                                                </Form.Group>
                                            </Col>
                                        </Row>
                                        <Form.Group>
                                            <TextInput
                                                name="phoneNumber"
                                                id="phoneNumber"
                                                label="Primary Phone Number"
                                                value={props.formState.phoneNumber}
                                                onChange={e => handleValueChange('phoneNumber', e.target.value)}
                                                errors={errors.phoneNumber}
                                                inputRef={register}
                                                InputProps={{
                                                    inputComponent: InputMaskPhone,
                                                }}
                                            />
                                        </Form.Group>
                                    </React.Fragment>
                                )}
                            </Col>
                        </Row>
                        <div className='backnext-wrapper'>
                            <BackNext nextDisabled={getDisabled} onBack={props.onBack} isAflac={true} continueLabel={{text: "Next"}} />
                        </div>
                    </Form>
                </Col>
            </Row>
        </Container>
    );
}

ThirdPartyDemoGraphic.propTypes = {
    formState: PropTypes.object.isRequired,
    onNext: PropTypes.func,
    onFieldChange: PropTypes.func.isRequired,
    onBack: PropTypes.func,
};

ThirdPartyDemoGraphic.ValidationSchema = object().shape({
    includeSecondaryAddressee: string().required('This field is required.'),
    firstName: customValidators.string().when('includeSecondaryAddressee', {
        is: 'yes',
        then: customValidators.string().isValidNameWithFiftyChar("First name is required.", true),
        otherwise: customValidators.string().notRequired()
    }),
    middleInitial: customValidators.string().when('includeSecondaryAddressee', {
        is: 'yes',
        then: customValidators.string().isValidNameWithFiftyChar('Middle Initials is required', true),
        otherwise: string().notRequired()
    }),
    lastName: customValidators.string().when('includeSecondaryAddressee', {
        is: 'yes',
        then: customValidators.string()
            .isValidNameWithFiftyChar("Last name is required.", true),
        otherwise: string().notRequired()
    }),
    street: string().when('includeSecondaryAddressee', {
        is: 'yes',
        then: customValidators.string().isValidNameLimitedSpecialChar('Street is required.', true, true),
        otherwise: string().notRequired()
    }),
    city: string().when('includeSecondaryAddressee', {
        is: 'yes',
        then: string().isValidNameLimitedSpecialChar('City is required.', true, false),
        otherwise: string().notRequired()
    }),
    state: string().when('includeSecondaryAddressee', {
        is: 'yes',
        then: string().required("State is required."),
        otherwise: string().notRequired()
    }),
    zip: customValidators.string().when('includeSecondaryAddressee', {
        is: 'yes',
        then: customValidators.string()
            .required("Zip is required.")
            .matches(/^[0-9]{5}$/, 'Zip code must be 5 number characters.'),
        otherwise: string().notRequired()
    }),
    phoneNumber: customValidators.string().when('includeSecondaryAddressee', {
        is: 'yes',
        then: customValidators.string()
            .required('Phone Number is required.')
            .matches(/^\(\d{3}\)\s\d{3}-\d{4}$/, 'Phone must be formatted as (123) 456-7890'),
        otherwise: string().notRequired()
    }),
})
ThirdPartyDemoGraphic.DefaultFormState = (prefill = false, basicInfo = null) => {
    return {
        includeSecondaryAddressee: '',
        firstName: (basicInfo && basicInfo.firstName) || '',
        middleInitial: (basicInfo && basicInfo.middleInitial) || '',
        lastName: (basicInfo && basicInfo.lastName) || '',
        street: (basicInfo && basicInfo.street) || '',
        city: (basicInfo && basicInfo.city) || '',
        state: (basicInfo && basicInfo.state) || '',
        zip: (basicInfo && basicInfo.zip) || '',
        phoneNumber: (basicInfo && basicInfo.phoneNumber) || '',
    };
};



// WEBPACK FOOTER //
// ./src/components/Quoters/Aflac/steps/ThirdPartyDemoGraphic.js